//
//  site-routes.ts
//  moods-film-ui-master
//
//  Created by romainharvier@gmail.com on 10/08/2019.
//  Copyright © 2019 Moods. All rights reserved.
//

import { AppLanguages } from '@/utils/handlers/app-language-handler';
import { RouteConfig } from 'vue-router';
import ObjectWithSignature from '@/utils/interfaces/object-with-signature';

const Home = () => import('@/views/home/home.vue');
const Cineseries = () => import('@/views/cineseries/cineseries.vue');
const Startups = () => import('@/views/startups/startups.vue');

export default class SiteRoutes {

    public routes: RouteConfig[];

    constructor(routeLanguage: AppLanguages) {

        const strings: ObjectWithSignature = require(`@/strings/${routeLanguage}/navigation.json`);

        this.routes = [

            {
                path: strings.home.path,
                name: 'home-' + routeLanguage,
                component: Home,
                props: {lang: routeLanguage},
            },
            {
                path: strings.cineseries.path,
                name: 'cineseries-' + routeLanguage,
                component: Cineseries,
                props: {lang: routeLanguage},
            },
            {
                path: strings.startups.path,
                name: 'startups-' + routeLanguage,
                component: Startups,
                props: {lang: routeLanguage},
            },
            {
                path: '/en/startups',
                redirect: 'en/corporate',
            },
            {
                path: '/fr/startups',
                redirect: 'fr/corporate',
            },
        ];

    }

}
